"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = function (internalClassNames, propClassNames) {
    var staticSide;
    if (internalClassNames) {
        if (Array.isArray(internalClassNames)) {
            staticSide = internalClassNames
                .filter(function (cn) { return typeof cn === "string"; })
                .join(" ");
        }
        else if (typeof internalClassNames === "string") {
            staticSide = internalClassNames;
        }
        else if (typeof internalClassNames === "boolean") {
            staticSide = "";
        }
        else {
            throw new TypeError("Values passed as 'internalClassNames' argument must be either 'array' or 'string' type.");
        }
    }
    if (staticSide) {
        if (propClassNames) {
            return staticSide + " " + propClassNames;
        }
        return staticSide;
    }
    if (propClassNames) {
        return propClassNames;
    }
    return "";
};
exports.default = classNames;
//# sourceMappingURL=index.js.map